import * as betprofessor from './Banner.styles.betprofessor';
import * as betroyale from './Banner.styles.betroyale';
import * as fiestabet from './Banner.styles.fiestabet';
import * as goldenrush from './Banner.styles.goldenrush';
import * as juicybet from './Banner.styles.juicybet';
import * as puntcity from './Banner.styles.puntcity';
import * as puntgenie from './Banner.styles.puntgenie';
import * as questbet from './Banner.styles.questbet';
import * as sterlingparker from './Banner.styles.sterlingparker';
import * as vikingbet from './Banner.styles.vikingbet';
import * as volcanobet from './Banner.styles.volcanobet';
import * as wellbet from './Banner.styles.wellbet';
import * as forsport from './Banner.styles.forsport';
import * as junglebet from './Banner.styles.junglebet';
import * as oldgill from './Banner.styles.oldgill';
import * as sugarcastle from './Banner.styles.sugarcastle';
import * as betgalaxy from './Banner.styles.betgalaxy';
import * as buffalobet from './Banner.styles.buffalobet';
import * as titanbet from './Banner.styles.titanbet';
import * as slambet from './Banner.styles.slambet';
import * as gigabet from './Banner.styles.gigabet';
import * as betstride from './Banner.styles.betstride';
import * as templebet from './Banner.styles.templebet';
import * as goldenbet888 from './Banner.styles.goldenbet888';
import * as hyperbet from './Banner.styles.hyperbet';
import * as bet777 from './Banner.styles.bet777';
import * as chromabet from './Banner.styles.chromabet';
import * as bet575 from './Banner.styles.bet575';
import * as betblast from './Banner.styles.betblast';
import * as pyramidbet from './Banner.styles.pyramidbet';
import * as magnumbet from './Banner.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
